module.exports = __webpack_public_path__ + "img/23.5d4f05f2.jpg";